import { eventCodeSchema, unifiedOrderStatusSchema, type UnifiedOrderStatus } from '@flux/shared';
import type { OrderFiltersValue } from './order-filters.js';

/**
 * Lit les filtres propres à Commandes depuis l'objet de recherche brut de la
 * route (`useSearch({strict:false})`, générique comme `useOriginFilter` —
 * voir `README-shell.md`). La route (`routes/commandes.tsx`) valide déjà la
 * forme exacte via `unifiedOrderListQuerySchema` ; cette relecture défensive
 * évite simplement un `as` non typé pour extraire les champs utiles à la
 * barre de filtres et à la requête de liste.
 */
export function readOrderFilters(search: unknown): OrderFiltersValue {
  const record = typeof search === 'object' && search !== null ? (search as Record<string, unknown>) : {};

  const rawStatus = record.status;
  const status = Array.isArray(rawStatus)
    ? rawStatus.filter((value): value is UnifiedOrderStatus => unifiedOrderStatusSchema.safeParse(value).success)
    : undefined;

  return {
    status: status && status.length > 0 ? status : undefined,
    from: typeof record.from === 'string' ? record.from : undefined,
    to: typeof record.to === 'string' ? record.to : undefined,
    search: typeof record.search === 'string' ? record.search : undefined,
    operationId: typeof record.operationId === 'string' ? record.operationId : undefined,
    withWarnings: record.withWarnings === true ? true : undefined,
    alertCode: eventCodeSchema.safeParse(record.alertCode).data,
    alertFrom: typeof record.alertFrom === 'string' ? record.alertFrom : undefined,
    alertTo: typeof record.alertTo === 'string' ? record.alertTo : undefined,
  };
}
